import React from 'react';

let Main = (props) => {
  let { children } = props;
  return <main className="flex-1 xl:overflow-y-auto flex flex-col bg-zinc-100">{children}</main>;
};
export default Main;
